import { Component, OnInit } from '@angular/core';
import { DepartmentBase } from '../department.base';

@Component({
  selector: 'dpto-81',
  templateUrl: './dpto81.component.html',
  styleUrls: ['../department/department.component.css']
})
export class Dpto81Component extends DepartmentBase {
  municipalities=[{"id":1048,"code":"81001","name":"Arauca","state":"1","department_code":"81"},{"id":1049,"code":"81065","name":"Arauquita","state":"1","department_code":"81"},{"id":1050,"code":"81220","name":"Cravo Norte","state":"1","department_code":"81"},{"id":1051,"code":"81300","name":"Fortul","state":"1","department_code":"81"},{"id":1052,"code":"81591","name":"Puerto Rond\u00f3n","state":"1","department_code":"81"},{"id":1053,"code":"81736","name":"Saravena","state":"1","department_code":"81"},{"id":1054,"code":"81794","name":"Tame","state":"1","department_code":"81"}]
}
